import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UI_COLORS, GRADIENTS, colorHelpers } from '../../utils/colors';
import { usePortalAuth } from '../../context/portalAuthContext';

/**
 * Read-only "profile submitted, awaiting approval" screen. A manual Refresh
 * re-fetches /me (no auto-poll — stays well under the rate limit); once the
 * staff approves, the shell routes to the full portal.
 */
const PortalPendingApproval = () => {
  const { t } = useTranslation();
  const s = t('portal.onboarding.pending', { returnObjects: true });
  const { customer, logout, refreshCustomer } = usePortalAuth();
  const [checking, setChecking] = useState(false);

  const check = async () => {
    setChecking(true);
    await refreshCustomer();
    setChecking(false);
  };

  return (
    <div className="min-h-full flex items-center justify-center p-4" style={{ background: GRADIENTS.NEUTRAL, backgroundColor: UI_COLORS.BACKGROUNDS.PRIMARY }}>
      <div className="w-full max-w-md rounded-2xl p-8 shadow-2xl text-center" style={{ backgroundColor: UI_COLORS.BACKGROUNDS.CARD }}>
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full" style={{ backgroundColor: colorHelpers.withOpacity(UI_COLORS.STATUS.INFO, 0.12) }}>
          <span className="text-2xl">⏳</span>
        </div>
        <h1 className="text-2xl font-bold mb-2" style={{ color: UI_COLORS.TEXT.PRIMARY }}>{s?.title || 'Awaiting approval'}</h1>
        <p className="text-sm mb-1" style={{ color: UI_COLORS.TEXT.SECONDARY }}>{s?.message || 'Thanks! Your profile has been submitted. Our team is reviewing it and you’ll get full access once approved.'}</p>
        {customer?.company_name && <p className="text-xs mb-6" style={{ color: UI_COLORS.TEXT.MUTED }}>{customer.company_name}</p>}

        <button type="button" onClick={check} disabled={checking} className="w-full py-3 rounded-xl font-semibold disabled:opacity-60 mb-3" style={{ background: GRADIENTS.PRIMARY, color: UI_COLORS.BUTTONS.PRIMARY.text }}>
          {checking ? (s?.checking || 'Checking…') : (s?.refresh || 'Check approval status')}
        </button>
        <button type="button" onClick={logout} className="w-full text-sm font-medium hover:underline" style={{ color: UI_COLORS.TEXT.ACCENT }}>
          {s?.logout || 'Log out'}
        </button>
      </div>
    </div>
  );
};

export default PortalPendingApproval;
